import apolloClient from '../apolloClient'
import configQueries from '../graphql/config'

const ymapsSettings = async function() {
  let apiKey = '';
  let suggestKey = '';
  
  try {
    const res = await apolloClient.query({
      query: configQueries.configsBatchGet,
      variables: {
        paramNames: ['ymaps_api_geocode_key', 'ymaps_api_suggest_key']
      }
    });
    
    if (res.data && res.data.configsBatchGet) {
      const configs = res.data.configsBatchGet.nodes;
      if (configs.length !== 2) {
        throw new Error('Error getting ymaps keys');
      }
      
      configs.forEach(conf => {
        if (conf.param === 'ymaps_api_geocode_key') {
          apiKey = conf.value;
        } else if (conf.param === 'ymaps_api_suggest_key') {
          suggestKey = conf.value;
        }
      })
    }

    apiKey += '&suggest_apikey=' + suggestKey;
  } catch (ex) {
    // ничего не делать, возможно пользователь не авторизован
  }
  
  let settings = {
    lang: 'ru_RU',
    coordorder: 'latlong',
    version: '2.1'
  }
  
  if (apiKey) {
    settings.apiKey = apiKey;
  }
  
  return settings;
}

export default ymapsSettings



// WEBPACK FOOTER //
// ./src/configs/ymapsSettings.js